module.exports = __webpack_public_path__ + "img/mona-lisa-display.2590f64a.png";